import { useEffect } from "react";
import { DISTRO_SCALE_SCRIPT_PATH } from "rivals/shared/constants";

export default function useNewRelicErrorHandler(): void {
  useEffect(() => {
    const newRelic = window?.newrelic;
    const isDistroScaleEnabled = !process.env.NEXT_PUBLIC_NEW_RELIC_FILTERS?.split(
      ","
    ).includes("distroscale");

    if (!newRelic) {
      return;
    }

    /**
     * https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/seterrorhandler/
     * API to selectively ignore known errors that the browser agent captures.
     * If the handler returns true, New Relic does not record the error.
     */
    newRelic.setErrorHandler((err): boolean => {
      const isIgnoredDistroScaleError =
        !isDistroScaleEnabled &&
        !!err?.stack?.includes(DISTRO_SCALE_SCRIPT_PATH);

      return !err || isIgnoredDistroScaleError;
    });
  }, []);
}
